/*
  TREASURE BOX - 가격 제안(자동 협상) 모달 로직
  ------------------------------------------------------------
  ".tb-price-offer-btn" 클래스를 가진 버튼(상품 상세페이지, 상품카드)을
  클릭하면 전역 모달(#tb-price-offer-modal)을 열고, 버튼의 data-* 속성에서
  상품 정보(상품ID, variant ID, 상품명, 현재가)를 읽어와 모달에 채워 넣습니다.

  negotiation-api(Cloudflare Worker)를 호출하는 2단계 흐름:
    1) POST {API_BASE}/api/offers        - 제안가 제출 -> 즉시 자동 판정
    2) POST {API_BASE}/api/offers/:token/confirm - 판정가로 주문 확정 -> Draft Order 생성

  기존 Shopify Contact Form(이메일 문의) 방식은 더 이상 사용하지 않습니다.
*/
// ---- Cloudflare Turnstile(캡차) 렌더링 ----
// 주의: 모달이 화면에 보이지 않는(hidden, display:none) 상태에서 Turnstile 위젯을
// 렌더링하면 내부 iframe 크기 계산이 어긋나 체크박스가 비정상적으로 표시되지
// 않는 경우가 있다(2026-10-07 확인). 그래서 페이지 로드 시점(onload 콜백)에는
// "Turnstile 라이브러리가 준비됐다"는 플래그만 세워두고, 실제 렌더링은 모달을
// 열 때(openModal, 컨테이너가 화면에 보이는 시점)에만 수행한다.
window.tbTurnstile = { widgetId: null, token: null, ready: false };
window.tbTurnstileOnload = function () {
  window.tbTurnstile.ready = true;
};

document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('tb-price-offer-overlay');
  var modal = document.getElementById('tb-price-offer-modal');
  if (!modal || !overlay) return;

  var API_BASE = modal.getAttribute('data-api-base') || '';

  var closeBtn = document.getElementById('tb-price-offer-close');
  var cancelBtn = document.getElementById('tb-price-offer-cancel');
  var productNameEl = document.getElementById('tb-price-offer-product-name');
  var currentPriceEl = document.getElementById('tb-price-offer-current-price');
  var descEl = document.getElementById('tb-price-offer-desc');

  var form = document.getElementById('TbPriceOfferForm');
  var priceInput = document.getElementById('TbPriceOfferForm-price');

  // 제안가 입력 중 자동으로 천단위 콤마 표시 (예: 1000000 -> 1,000,000)
  if (priceInput) {
    priceInput.addEventListener('input', function () {
      var digits = priceInput.value.replace(/[^0-9]/g, '');
      priceInput.value = digits ? Number(digits).toLocaleString('ko-KR') : '';
    });
  }
  var emailInput = document.getElementById('TbPriceOfferForm-email');
  var submitBtn = document.getElementById('tb-price-offer-submit-btn');
  var submitErrorBox = document.getElementById('tb-price-offer-submit-error');
  var submitErrorText = document.getElementById('tb-price-offer-submit-error-text');

  // 캡차 진행 상태 안내 UI (Managed/Non-interactive 모드에서 체크박스가 보이지 않고
  // 백그라운드에서 몇 초간 처리되거나, 드물게 실패(에러코드 600*) 후 자동 재시도가
  // 필요한 경우를 사용자에게 명확히 알려주기 위함. 2026-10-07 추가.
  var turnstileStatusBox = document.getElementById('tb-price-offer-turnstile-status');
  var turnstileStatusText = document.getElementById('tb-price-offer-turnstile-status-text');
  var turnstileRetryBtn = document.getElementById('tb-price-offer-turnstile-retry-btn');

  var resultWrap = document.getElementById('tb-price-offer-result');
  var resultOkBox = document.getElementById('tb-price-offer-result-ok');
  var resultHeadline = document.getElementById('tb-price-offer-result-headline');
  var resultPriceEl = document.getElementById('tb-price-offer-result-price');
  var resultNoteEl = document.getElementById('tb-price-offer-result-note');
  var confirmBtn = document.getElementById('tb-price-offer-confirm-btn');
  var retryBtn = document.getElementById('tb-price-offer-retry-btn');

  var resultRejectedBox = document.getElementById('tb-price-offer-result-rejected');
  var rejectedRetryBtn = document.getElementById('tb-price-offer-rejected-retry-btn');

  var resultIneligibleBox = document.getElementById('tb-price-offer-result-ineligible');

  var resultErrorBox = document.getElementById('tb-price-offer-result-error');
  var errorRetryBtn = document.getElementById('tb-price-offer-error-retry-btn');

  // 2026-10-18 신규: 자동차 상품의 가격 제안 확정 시(결제 페이지 없이 이메일로만
  // 전달되는 경우) 안내 메시지를 보여줄 결과 박스.
  var resultCarInquiryBox = document.getElementById('tb-price-offer-result-car-inquiry');

  var strings = window.tbPriceOfferStrings || {};

  var currentProduct = { productId: '', variantId: '', title: '', priceText: '', priceValue: null, available: true };
  var currentSessionToken = null;
  var currentFinalPrice = null;

  function formatWon(n) {
    try {
      return Number(n).toLocaleString('ko-KR') + '원';
    } catch (e) {
      return n + '원';
    }
  }

  // data-tb-product-price 속성(예: "₩305,000", "305,000원" 등 테마 money 필터 결과)에서
  // 숫자만 추출한다. 제안가가 현재 판매가보다 높은지 클라이언트에서 즉시 판별하는 데 사용.
  function parsePriceToNumber(priceText) {
    if (!priceText) return null;
    var digits = String(priceText).replace(/[^0-9]/g, '');
    if (!digits) return null;
    var n = parseInt(digits, 10);
    return isNaN(n) ? null : n;
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    var label = btn.querySelector('span:not(.tb-price-offer-spinner)');
    var spinner = btn.querySelector('.tb-price-offer-spinner');
    btn.disabled = !!loading;
    if (spinner) spinner.hidden = !loading;
    if (label) label.style.visibility = loading ? 'hidden' : 'visible';
  }

  // ---- 캡차 진행 상태 안내 표시/숨김 ----
  function showTurnstileStatus(message, showRetry, isSuccess) {
    if (!turnstileStatusBox) return;
    if (turnstileStatusText) turnstileStatusText.textContent = message || '';
    if (turnstileRetryBtn) turnstileRetryBtn.hidden = !showRetry;
    turnstileStatusBox.classList.toggle('tb-price-offer-turnstile-status--success', !!isSuccess);
    turnstileStatusBox.hidden = false;
  }
  function hideTurnstileStatus() {
    if (!turnstileStatusBox) return;
    turnstileStatusBox.hidden = true;
    turnstileStatusBox.classList.remove('tb-price-offer-turnstile-status--success');
    if (turnstileRetryBtn) turnstileRetryBtn.hidden = true;
  }

  function showStep1() {
    form.hidden = false;
    resultWrap.hidden = true;
    [resultOkBox, resultRejectedBox, resultIneligibleBox, resultErrorBox].forEach(function (box) {
      if (box) box.hidden = true;
    });
    submitErrorBox.hidden = true;
    hideTurnstileStatus();
  }

  function showResultBox(box) {
    form.hidden = true;
    resultWrap.hidden = false;
    [resultOkBox, resultRejectedBox, resultIneligibleBox, resultErrorBox, resultCarInquiryBox].forEach(function (b) {
      if (b) b.hidden = b !== box;
    });
  }

  function resetModalState() {
    currentSessionToken = null;
    currentFinalPrice = null;
    priceInput.value = '';
    showStep1();
    // 재시도/재오픈 시 이전 캡차 토큰은 1회용이므로 반드시 새로 받아야 함
    if (window.turnstile && window.tbTurnstile && window.tbTurnstile.widgetId !== null) {
      try { window.turnstile.reset(window.tbTurnstile.widgetId); } catch (e) {}
      window.tbTurnstile.token = null;
    }
  }

  // 모달이 "화면에 보이게 된 다음"에만 Turnstile 위젯을 렌더링한다(숨은 컨테이너에
  // 렌더링하면 iframe이 비정상적으로 그려지는 문제를 피하기 위함). 이미 렌더링된
  // 위젯이 있으면 다시 만들지 않고 그대로 재사용한다(토큰 리셋은 resetModalState에서 처리).
  var turnstileContainer = document.getElementById('tb-price-offer-turnstile');
  function ensureTurnstileRendered(attempt) {
    attempt = attempt || 0;
    if (window.tbTurnstile && window.tbTurnstile.widgetId !== null) return; // 이미 렌더링됨
    if (window.turnstile && window.tbTurnstile && window.tbTurnstile.ready && turnstileContainer) {
      var siteKey = modal.getAttribute('data-turnstile-site-key') || '';
      if (!siteKey) return;
      window.tbTurnstile.widgetId = window.turnstile.render(turnstileContainer, {
        sitekey: siteKey,
        // Non-interactive 모드에서도 신뢰도가 높은 방문자는 위젯이 보일 틈도
        // 없이(수백ms 내) 검증이 끝나버려 "위젯이 전혀 안 보인다"고 느껴질 수
        // 있다. appearance를 명시적으로 'always'로 지정해 위젯 자체는 항상
        // 화면에 그려지도록 강제하고, size도 'normal'로 고정한다(2026-10-07).
        appearance: 'always',
        size: 'normal',
        // 기본 재시도 간격(8000ms)이 다소 길어, 실패(에러코드 600*) 후 복구까지
        // 사용자가 오래 기다리는 느낌을 받을 수 있다. 3000ms로 단축해 자동
        // 복구를 더 빠르게 시도하도록 한다(2026-10-07).
        retry: 'auto',
        'retry-interval': 3000,
        callback: function (token) {
          window.tbTurnstile.token = token;
          // 검증이 너무 빨리 끝나 위젯이 보일 새 없이 사라지는 경우가 많으므로,
          // "보안 확인 완료" 배지를 짧게라도 눈에 보이게 띄워 신뢰감을 준다
          // (2026-10-07 추가).
          showTurnstileStatus(strings.turnstileSuccessMessage || '보안 확인이 완료되었습니다.', false, true);
          setTimeout(function () {
            // 사용자가 아직 폼을 제출하지 않았다면 안내를 조용히 숨긴다.
            if (!submitBtn.disabled) hideTurnstileStatus();
          }, 2500);
        },
        'expired-callback': function () {
          window.tbTurnstile.token = null;
        },
        'error-callback': function () {
          window.tbTurnstile.token = null;
          // Turnstile이 자체적으로 자동 재시도를 진행 중이므로 당장 에러로
          // 단정하지 않고, "처리 중" 안내만 띄워 사용자가 계속 기다리거나
          // 수동으로 다시 시도할 수 있게 한다.
          showTurnstileStatus(strings.turnstilePendingMessage || '보안 확인 처리 중입니다. 잠시만 기다려 주세요...', true);
        },
      });
      return;
    }
    // Turnstile 스크립트가 아직 네트워크에서 로딩 중일 수 있으므로 짧게 재시도
    // (최대 20회 x 300ms = 6초). 그 이상 실패하면 네트워크/차단 문제로 간주하고 중단.
    if (attempt < 20) {
      setTimeout(function () {
        ensureTurnstileRendered(attempt + 1);
      }, 300);
    }
  }

  // 캡차 토큰이 발급될 때까지 최대 maxWaitMs 동안 짧은 간격으로 확인한다.
  // Managed/Non-interactive 모드는 체크박스를 보여주지 않고 백그라운드에서
  // 몇 초간 조용히 처리하는 것이 정상 동작이므로, 제출 시점에 토큰이 아직
  // 없다고 해서 즉시 실패로 간주하지 않고 잠시 기다려주는 것이 핵심이다
  // (2026-10-07: 이 대기 로직이 없어 "제출 눌러도 반응 없음"처럼 보이는
  // 문제의 원인이었음 - 실제로는 백그라운드 검증이 끝나지 않았는데 즉시
  // 동일한 안내 문구만 다시 보여줬기 때문).
  function waitForTurnstileToken(maxWaitMs) {
    return new Promise(function (resolve) {
      var waited = 0;
      var step = 250;
      var timer = setInterval(function () {
        if (window.tbTurnstile && window.tbTurnstile.token) {
          clearInterval(timer);
          resolve(window.tbTurnstile.token);
          return;
        }
        waited += step;
        if (waited >= maxWaitMs) {
          clearInterval(timer);
          resolve(null);
        }
      }, step);
    });
  }

  if (turnstileRetryBtn) {
    turnstileRetryBtn.addEventListener('click', function () {
      showTurnstileStatus(strings.turnstilePendingMessage || '보안 확인 처리 중입니다. 잠시만 기다려 주세요...', false);
      if (window.turnstile && window.tbTurnstile && window.tbTurnstile.widgetId !== null) {
        try { window.turnstile.reset(window.tbTurnstile.widgetId); } catch (e) {}
        window.tbTurnstile.token = null;
      } else {
        // 위젯이 아예 렌더링되지 못한 상태였다면 처음부터 다시 시도
        ensureTurnstileRendered();
      }
      waitForTurnstileToken(12000).then(function (token) {
        if (token) {
          hideTurnstileStatus();
        } else {
          showTurnstileStatus(strings.turnstileTimeoutMessage || '보안 확인이 지연되고 있습니다. 다시 시도해 주세요.', true);
        }
      });
    });
  }

  function openModal(trigger) {
    currentProduct.productId = trigger.getAttribute('data-tb-product-id') || '';
    currentProduct.variantId = trigger.getAttribute('data-tb-variant-id') || '';
    currentProduct.title = trigger.getAttribute('data-tb-product-title') || '';
    currentProduct.priceText = trigger.getAttribute('data-tb-product-price') || '';
    currentProduct.priceValue = parsePriceToNumber(currentProduct.priceText);

    if (productNameEl) productNameEl.textContent = currentProduct.title;
    if (currentPriceEl) currentPriceEl.textContent = currentProduct.priceText;

    resetModalState();

    overlay.hidden = false;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    ensureTurnstileRendered();

    setTimeout(function () {
      if (priceInput) priceInput.focus();
    }, 50);
  }

  function closeModal() {
    overlay.hidden = true;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.tb-price-offer-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal(btn);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (cancelBtn) cancelBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  // ---- STEP 1: 제안가 제출 -> 자동 판정 ----
  function doSubmitOffer(offerPrice, turnstileToken) {
    setLoading(submitBtn, true);

    fetch(API_BASE + '/api/offers', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shopify_product_id: currentProduct.productId,
        variant_id: currentProduct.variantId,
        product_title: currentProduct.title,
        quantity: 1,
        offer_price: offerPrice,
        customer_email: emailInput.value.trim() || null,
        turnstile_token: turnstileToken,
      }),
    })
      .then(function (resp) {
        return resp.json().then(function (data) {
          return { status: resp.status, data: data };
        });
      })
      .then(function (res) {
        setLoading(submitBtn, false);
        var data = res.data;

        if (res.status === 404 && data.error === 'product_not_eligible') {
          showResultBox(resultIneligibleBox);
          return;
        }
        if (res.status === 400 && data.error === 'turnstile_failed') {
          submitErrorText.textContent = strings.turnstileFailedMessage || '사람 확인(캡차)에 실패했습니다. 다시 시도해 주세요.';
          submitErrorBox.hidden = false;
          if (window.turnstile && window.tbTurnstile && window.tbTurnstile.widgetId !== null) {
            try { window.turnstile.reset(window.tbTurnstile.widgetId); } catch (e) {}
            window.tbTurnstile.token = null;
          }
          return;
        }
        if (res.status === 429) {
          submitErrorText.textContent = (data && data.message) || '잠시 후 다시 시도해 주세요.';
          submitErrorBox.hidden = false;
          return;
        }
        if (res.status === 400 && data.error === 'invalid_offer_price') {
          // 2026-10-10: 고가(예: 자동차) 상품에 비정상적으로 큰 금액을 입력한
          // 경우 등 서버가 제안가 자체를 거부했을 때, 의미 없는 일반 오류
          // 대신 명확한 안내를 보여준다.
          submitErrorText.textContent = strings.invalidPriceMessage || '제안 가능한 가격 범위를 벗어났습니다. 금액을 다시 확인해 주세요.';
          submitErrorBox.hidden = false;
          return;
        }
        if (res.status !== 200 || !data.session_token) {
          submitErrorText.textContent = strings.genericErrorMessage || '처리 중 오류가 발생했습니다. 다시 시도해 주세요.';
          submitErrorBox.hidden = false;
          return;
        }

        currentSessionToken = data.session_token;

        if (data.decision === 'rejected') {
          showResultBox(resultRejectedBox);
          return;
        }

        currentFinalPrice = data.final_price;
        if (data.decision === 'approved') {
          resultHeadline.textContent = strings.approvedHeadline || '제안하신 가격으로 주문이 가능합니다!';
        } else {
          resultHeadline.textContent = strings.counteredHeadline || '아래 가격은 어떠신가요?';
        }
        resultPriceEl.textContent = formatWon(data.final_price);
        resultNoteEl.textContent = strings.expiresNote
          ? strings.expiresNote.replace('{{ minutes }}', data.expires_in_minutes || 300)
          : '이 가격은 ' + (data.expires_in_minutes || 300) + '분 동안 유효합니다.';
        showResultBox(resultOkBox);
      })
      .catch(function () {
        setLoading(submitBtn, false);
        submitErrorText.textContent = strings.networkErrorMessage || '네트워크 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
        submitErrorBox.hidden = false;
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitErrorBox.hidden = true;

      var offerPrice = parseInt(priceInput.value.replace(/[^0-9]/g, ''), 10);
      if (!offerPrice || offerPrice <= 0) {
        submitErrorText.textContent = strings.invalidPriceMessage || '올바른 가격을 입력해 주세요.';
        submitErrorBox.hidden = false;
        return;
      }
      // 제안가가 현재 판매가보다 높거나 같으면 가격 제안을 받는 의미가 없으므로,
      // 서버 호출 전에 즉시 안내하고 다시 입력하도록 한다(2026-10-10 추가).
      if (currentProduct.priceValue != null && offerPrice >= currentProduct.priceValue) {
        submitErrorText.textContent = strings.priceTooHighMessage || '제안 가격이 현재 판매가보다 높습니다. 현재 판매가보다 낮은 금액으로 다시 제안해 주세요.';
        submitErrorBox.hidden = false;
        priceInput.focus();
        return;
      }
      if (!currentProduct.productId) {
        submitErrorText.textContent = strings.missingProductMessage || '상품 정보를 확인할 수 없습니다. 새로고침 후 다시 시도해 주세요.';
        submitErrorBox.hidden = false;
        return;
      }

      var existingToken = (window.tbTurnstile && window.tbTurnstile.token) || '';
      if (existingToken) {
        doSubmitOffer(offerPrice, existingToken);
        return;
      }

      // 캡차 토큰이 아직 없는 경우: Managed/Non-interactive 모드는 체크박스를
      // 보여주지 않고 백그라운드에서 몇 초간 조용히 처리하는 것이 정상이므로,
      // 즉시 실패로 안내하지 않고 "처리 중" 상태를 보여주며 최대 12초 대기한다.
      // 그 사이 토큰이 발급되면 자동으로 제안을 제출하고, 끝까지 발급되지
      // 않으면 그때 명확한 안내(+다시 시도 버튼)를 보여준다.
      setLoading(submitBtn, true);
      showTurnstileStatus(strings.turnstilePendingMessage || '보안 확인 처리 중입니다. 잠시만 기다려 주세요...', false);

      waitForTurnstileToken(12000).then(function (token) {
        if (token) {
          hideTurnstileStatus();
          doSubmitOffer(offerPrice, token);
          return;
        }
        setLoading(submitBtn, false);
        showTurnstileStatus(strings.turnstileTimeoutMessage || '보안 확인이 지연되고 있습니다. 아래 "다시 시도" 버튼을 눌러 주세요.', true);
        submitErrorText.textContent = strings.turnstileMissingMessage || '사람 확인(캡차)을 완료해 주세요.';
        submitErrorBox.hidden = false;
      });
    });
  }

  // ---- STEP 2: 주문 확정(Draft Order 생성) -> 결제 페이지로 이동 ----
  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (!currentSessionToken) return;
      setLoading(confirmBtn, true);

      fetch(API_BASE + '/api/offers/' + currentSessionToken + '/confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_email: emailInput.value.trim() || null,
          // 2026-10-10: 결제창(Draft Order 체크아웃)의 할인 제목/설명을 고객이
          // 보고 있는 언어로 표시하기 위해, 테마가 이미 알고 있는 현재 페이지
          // 언어(<html lang="...">, request.locale.iso_code와 동일)를 함께
          // 전달한다. 영어/일본어 체크아웃에서도 한국어 할인 문구가 그대로
          // 노출되던 문제를 해결하기 위한 조치.
          locale: (document.documentElement.getAttribute('lang') || '').slice(0, 2) || 'ko',
        }),
      })
        .then(function (resp) {
          return resp.json().then(function (data) {
            return { status: resp.status, data: data };
          });
        })
        .then(function (res) {
          setLoading(confirmBtn, false);
          if (res.status === 200 && res.data.ok && res.data.invoice_url) {
            // 2026-10-10: 할인 라인 제목(예: "NEGOTIATED PRICE...")은 영어로
            // 바뀌었는데 "소계/배송/총계" 같은 체크아웃 기본 UI는 한국어
            // 그대로 노출된다는 피드백을 받음. 원인: invoice_url에 언어
            // 파라미터가 없으면 Shopify가 스토어 기본 언어(한국어)로 체크아웃을
            // 연다. 결제 페이지로 이동할 때도 현재 페이지 언어를 ?locale=
            // 파라미터로 함께 넘겨 체크아웃 전체가 같은 언어로 표시되게 한다.
            var pageLocale = (document.documentElement.getAttribute('lang') || '').slice(0, 2) || 'ko';
            var sep = res.data.invoice_url.indexOf('?') === -1 ? '?' : '&';
            window.location.href = res.data.invoice_url + sep + 'locale=' + pageLocale;
            return;
          }
          // 2026-10-18 신규: 자동차 상품은 결제 페이지 대신 담당자 이메일로
          // 제안 내용이 전달됨. is_car_inquiry:true 응답은 오류가 아니라
          // 정상 처리 결과이므로 전용 안내 화면을 보여준다.
          if (res.status === 200 && res.data.ok && res.data.is_car_inquiry) {
            showResultBox(resultCarInquiryBox);
            return;
          }
          showResultBox(resultErrorBox);
        })
        .catch(function () {
          setLoading(confirmBtn, false);
          showResultBox(resultErrorBox);
        });
    });
  }

  // 다시 제안하기 (승인/역제안 화면에서)
  if (retryBtn) retryBtn.addEventListener('click', resetModalState);
  // 다시 제안하기 (거절 화면에서)
  if (rejectedRetryBtn) rejectedRetryBtn.addEventListener('click', resetModalState);
  // 다시 시도 (일반 오류 화면에서) - 이전 판정 결과로 복귀
  if (errorRetryBtn) {
    errorRetryBtn.addEventListener('click', function () {
      showResultBox(resultOkBox);
    });
  }
});
